export default {
	UnFilterUser: "UnFilterUser",
	ChangeFiltersUser: "ChangeFiltersUser",
	Date2HoursLineClicked: "Date2HoursLineClicked",
	BirthdayMessage: "BirthdayMessage",
	RemoveChatRecievedUser: "RemoveChatRecievedUser",
	RemoveChatSentUser: "RemoveChatSentUser",
};
